<template>
	<div class="card-box" :class="{selected:isSelected}" @click="selectCard">
		<el-row class="card-info" :gutter="20">
			<el-col class="flex-row" :span="16">
				<img class="card-icon" :src="getIconUrl(cardinfo)" />
				<div class="card-bankname" :title="cardinfo.belongBankName">{{cardinfo.belongBankName}}</div>
			</el-col>
			<el-col :span="3">
				<div class="handle-icon" @click.stop="edit"> <i class="el-icon-edit-outline"></i></div>
			</el-col>
			<el-col :span="3">
				<div class="handle-icon" @click.stop="remove"> <i class="el-icon-delete"></i></div>
			</el-col>
		</el-row>
		<div class="card-account">{{cardinfo.accountName}}</div>
		<div class="card-account">{{cardinfo.accountNumber}}</div>
	</div>
</template>

<script>
	export default {
		name: "address-detail",
		props: {
			cardinfo: {
				type: Object,
				default: function() {
					return {};
				}
			},
			selectinfo: {
				type: Object,
				default: function() {
					return {};
				}
			},
		},
		data() {
			return {
				bankOptionList: [
					'招商银行',
					'工商银行',
					'建设银行',
					'中信银行',
					'浦发银行',
					'江苏银行',
					'中国银行',
					'中国农业银行',
					'交通银行',
					'中国民生银行',
					'华夏银行',
					'中国邮政储蓄银行',
					'东莞农村农业银行',
					'浙江泰隆商业银行',
					'广发银行',
					'北京银行',
					'平安银行',
					'南京银行',
				],
			}
		},

		computed: {
			isSelected() {
				return this.selectinfo.id == this.cardinfo.id
			},
		},
		methods: {
			edit() {
				this.$emit('edit', this.cardinfo);
			},
			remove() {
				this.$emit('remove', this.cardinfo);
			},
			selectCard() {
				this.$emit('selectCard', this.cardinfo);
			},
			getIconUrl(cardInfo) {
				return `http://jkyun--jmall.oss-cn-hangzhou.aliyuncs.com/jmc/huifu-bigamount/${this.bankOptionList.includes(cardInfo.belongBankName)? cardInfo.belongBankName : '默认银行'}.svg`
			},
		}
	}
</script>

<style scoped="scoped">
	.card-box {
		height: 100px;
		color: #999;
		margin-bottom: 20px;
		font-size: 18px;
		border: 1px solid #dedede;
		cursor: pointer;
		padding: 5px 10px;
	}

	.card-box::-webkit-scrollbar {
		display: none;
	}

	.card-info {
		display: flex;
		align-items: center;
		color: #000;
		font-size: 16px;
	}

	.card-icon {
		width: 20px;
		margin-right: 10px;
	}

	.card-account {
		font-size: 15px;
		margin-top: 8px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		/*设置对其模式 */
		-webkit-line-clamp: 1;
		/*设置多行的行数*/
	}
	
	.card-bankname{
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.handle-icon {
		font-size: 25px;
		cursor: pointer;
	}

	.selected {
		border: 1px solid #FF5757 !important;
	}
</style>